import React, { Component } from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { withNamespaces } from 'react-i18next'
import { Col } from 'reactstrap'
import styled from 'styled-components'

import { fetchNews } from '../../ducks/news'

import Preloader from '../../components/UI/Preloader'
import NewsItem from '../../components/Dashboard/NewsItem'
import NewsModal from '../../components/Dashboard/NewsModal'

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  background-color: #fff;

  margin-bottom: 20px;
  padding: 26px 15px 26px 25px;
`

const StyledTitle = styled.div`
  color: #2e384d;
  font-family: 'Open Sans', sans-serif;
  font-size: 15px;
  font-weight: 500;
  margin-bottom: 4px;
`

class NewsList extends Component {
  state = {
    modal: false,
    currentNews: null
  }

  componentDidMount() {
    this.props.fetchNews()
  }

  renderNews = () => {
    const { news } = this.props
    const { entities } = news

    return entities.map((news) => (
      <NewsItem key={news.time} openModal={this.toggleModal} news={news} />
    ))
  }

  render() {
    const { currentNews, modal } = this.state
    const { t, news } = this.props
    const { loading } = news

    return (
      <Col md={12} lg={6}>
        <Wrapper>
          {loading && <Preloader />}
          <StyledTitle>{t('common:news')}</StyledTitle>
          {this.renderNews()}
          <NewsModal
            isOpen={modal}
            news={currentNews}
            toggle={() => this.toggleModal(false, null)}
          />
        </Wrapper>
      </Col>
    )
  }

  toggleModal = (value, news) => {
    this.setState({
      modal: value,
      currentNews: news
    })
  }
}

export default compose(
  connect(
    ({ news }) => ({
      news
    }),
    { fetchNews }
  ),
  withNamespaces()
)(NewsList)
